/**
 * Financial Profile Store
 * Zustand store for managing financial profile state
 */

import create from 'zustand';
import type { FinancialProfile } from '../api/types';

interface ProfileState {
  profile: FinancialProfile | null;
  hasProfile: boolean;
  isLoading: boolean;
  error: string | null;

  // Actions
  setProfile: (profile: FinancialProfile) => void;
  updateProfile: (updates: Partial<FinancialProfile>) => void;
  setHasProfile: (hasProfile: boolean) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearProfile: () => void;
}

export const useProfileStore = create<ProfileState>((set) => ({
  profile: null,
  hasProfile: false,
  isLoading: false,
  error: null,

  setProfile: (profile) =>
    set({
      profile,
      hasProfile: true,
      error: null,
    }),

  updateProfile: (updates) =>
    set((state) => ({
      profile: state.profile
        ? { ...state.profile, ...updates }
        : (updates as FinancialProfile),
      hasProfile: true,
    })),

  setHasProfile: (hasProfile) => set({ hasProfile }),

  setLoading: (isLoading) => set({ isLoading }),

  setError: (error) => set({ error }),

  clearProfile: () =>
    set({
      profile: null,
      hasProfile: false,
      error: null,
    }),
}));

